import { ActionContext } from "vuex"
import { IRootState } from ".."
interface IArticleState {
  detail: null
  commentList: null
  count: null
}

type Context = ActionContext<IArticleState, IRootState>

export const article = {
  namespaced: true,
  state: () => ({
    detail: null,
    commentList: null,
    count: null
  }),
  getters: {
    detail: state => state.detail,
    commentList: state => state.commentList,
    count: state => state.count
  },
  mutations: {
    SET_DETAIL: (state: IArticleState, { detail }) => {
      state.detail = detail
    },
    SET_COMMENT_LIST: (state: IArticleState, { commentList }) => {
      state.commentList = commentList
    },
    SET_COUNT: (state: IArticleState, { count }) => {
      state.count = count
    }
  },
  actions: {
    FETCH_DETAIL: ({ commit, rootState: { api } }: Context, { article_id }) => {
      return api.article
        .detail(article_id)
        .then(res => commit("SET_DETAIL", { detail: res.data }))
    },
    FETCH_COMMENT_LIST: (
      { commit, rootState: { api } }: Context,
      { article_id, params }
    ) => {
      return api.article.comments(article_id, params).then(res =>
        commit("SET_COMMENT_LIST", {
          commentList: res.data
        })
      )
    },
    FETCH_COUNT: ({ commit, rootState: { api } }: Context, { article_id }) => {
      return api.article
        .count(article_id)
        .then(res => commit("SET_COUNT", { count: res.data[0]?.num || "" }))
    }
  }
}
